import { createAction, props } from '@ngrx/store';
import { PathologyDto, CreatePathologyDto } from '@shared/dto';
import { PaginatedListQuery } from '@shared/interfaces/paginated-list-query.interface';

// Load list
export const readPathologies = createAction('@app/pathology/read', (params?: string | number | Record<string, string | number>, query?: PaginatedListQuery) => ({ params, query }));
export const readPathologiesSuccess = createAction('@app/pathology/read/success', props<{ data: PathologyDto[]; total: number }>());
export const readPathologiesFailure = createAction('@app/pathology/read/failure', props<{ error: any }>());

// Create
export const createPathology = createAction('@app/pathology/create', props<{ dto: CreatePathologyDto }>());
export const createPathologySuccess = createAction('@app/pathology/create/success', props<{ pathology: PathologyDto }>());
export const createPathologyFailure = createAction('@app/pathology/create/failure', props<{ error: any }>());

// Update
export const updatePathology = createAction('@app/pathology/update', props<{ pathologyId: number; dto: any }>());
export const updateClientSuccess = createAction('@app/pathology/update/success', props<{ pathology: Partial<PathologyDto> }>());
export const updateClientFailure = createAction('@app/pathology/update/failure', props<{ error: any }>());

// Delete
export const deletePathology = createAction('@app/pathology/delete', props<{ pathologyId: number }>());
export const deletePathologySuccess = createAction('@app/pathology/delete/success', props<{ pathology: PathologyDto }>());
export const deletePathologyFailure = createAction('@app/pathology/delete/failure', props<{ error: any }>());

// Restore
export const restorePathology = createAction('@app/pathology/restore', props<{ pathologyId: number }>());
export const restorePathologySuccess = createAction('@app/pathology/restore/success', props<{ pathology: PathologyDto }>());
export const restorePathologyFailure = createAction('@app/pathology/restore/failure', props<{ error: any }>());
